import { RoleHost } from '../RoleHost';

export function DCWrapper() {
  return <RoleHost role="dc" />;
}
